// CLEAR LENS MILANO — costanti condivise (dati reali dai materiali ufficiali)

export const BRAND = "CLEAR LENS MILANO";
export const AREA = "Milano Est e Hinterland";

export const PHONE_DISPLAY = "+39 340 416 0311";
export const PHONE_TEL = "tel:+393404160311";
export const INSTAGRAM_URL = "https://www.instagram.com/clearlensmilano/";

const WHATSAPP_MESSAGE =
    "Ciao CLEAR LENS MILANO, vorrei informazioni sul ripristino dei fari della mia auto. Posso inviarvi alcune fotografie per una valutazione?";
export const WHATSAPP_URL = `https://wa.me/393404160311?text=${encodeURIComponent(
    WHATSAPP_MESSAGE,
)}`;

export const NAV_LINKS = [
    { label: "Il Servizio", href: "#servizio" },
    { label: "Prezzi", href: "#prezzi" },
    { label: "Prima/Dopo", href: "#prima-dopo" },
    { label: "FAQ", href: "#faq" },
    { label: "Contatti", href: "#contatti" },
];

// Listino reale dal volantino ufficiale
export const PACKAGES = [
    {
        id: "clear",
        name: "CLEAR",
        price: "59€",
        condition: "Opacità superficiale",
        features: [
            "Pulizia profonda",
            "Lucidatura tecnica",
            "Protezione nanotecnologica CarPro C.Quartz DLUX",
        ],
        note: "Durata garantita fino a 2 anni",
        highlight: false,
    },
    {
        id: "vision",
        name: "VISION",
        price: "79€",
        condition: "Opacità avanzata",
        features: [
            "Pulizia profonda",
            "Carteggiatura intermedia",
            "Lucidatura tecnica",
            "Protezione nanotecnologica CarPro C.Quartz DLUX",
        ],
        note: "Durata garantita fino a 2 anni",
        highlight: false,
    },
    {
        id: "crystal",
        name: "CRYSTAL",
        price: "109€",
        condition: "Opacità grave",
        features: [
            "Restauro completo",
            "Carteggiatura approfondita per rimuovere ossidazione grave",
            "Lucidatura multistadio ad alta definizione",
            "Protezione nanotecnologica CarPro C.Quartz DLUX",
        ],
        note: "Durata garantita fino a 2 anni",
        highlight: false,
    },
    {
        id: "upgrade",
        name: "UPGRADE PREMIUM",
        price: "+15€",
        condition: "Applicabile a qualsiasi pacchetto",
        features: [
            "Protezione d'élite CarPro C.Quartz DLight",
            "Finitura superiore e protezione prolungata",
        ],
        note: "Durata garantita fino a 3 anni",
        highlight: true,
    },
];

export const PROCESS_STEPS = [
    {
        title: "Contattaci su WhatsApp",
        text: "Scrivici direttamente: parlerai con chi esegue il lavoro, senza intermediari.",
    },
    {
        title: "Invia le foto dei fari",
        text: "Alcune fotografie dei fari e una descrizione del problema ci aiutano a inquadrare il caso.",
    },
    {
        title: "Ricevi il preventivo gratuito",
        text: "Un primo riscontro onesto: ti diciamo se l'intervento è adatto e quale trattamento serve.",
    },
    {
        title: "Concordiamo l'intervento",
        text: "Se il caso è adatto al servizio, fissiamo l'appuntamento a domicilio nella tua zona.",
    },
];

export const WHY_POINTS = [
    {
        title: "Servizio a domicilio",
        text: `Niente officina: lavoriamo dove si trova la tua auto, a ${AREA}.`,
    },
    {
        title: "Contatto diretto",
        text: "Comunichi su WhatsApp con l'operatore, non con un call center.",
    },
    {
        title: "Preventivi gratuiti",
        text: "Mandi le foto, ricevi una valutazione chiara senza impegno.",
    },
    {
        title: "Attenzione alla singola vettura",
        text: "Ogni faro viene valutato e trattato in base alle sue condizioni reali.",
    },
    {
        title: "Valutazione onesta",
        text: "Se un faro non è recuperabile, te lo diciamo prima. Il risultato dipende dalle condizioni iniziali.",
    },
    {
        title: "Protezione nanotecnologica",
        text: "Finitura con prodotti CarPro C.Quartz per fari protetti e splendenti nel tempo.",
    },
];

export const FAQS = [
    {
        q: "In cosa consiste il ripristino dei fari?",
        a: "È un trattamento estetico e funzionale del policarbonato esterno: pulizia profonda, carteggiatura e lucidatura (secondo il pacchetto) e protezione nanotecnologica finale. L'obiettivo è recuperare trasparenza e brillantezza del faro.",
    },
    {
        q: "Tutti i fari possono essere recuperati?",
        a: "No. Il risultato dipende dalle condizioni iniziali del faro. Danni interni, infiltrazioni, problemi elettrici o crepe strutturali non si risolvono con un trattamento estetico: per questo valutiamo ogni caso dalle fotografie prima di confermare.",
    },
    {
        q: "Quanto costa il servizio?",
        a: "I trattamenti partono da 59€ (pacchetto CLEAR). VISION 79€, CRYSTAL 109€, Upgrade Premium +15€. Il pacchetto adatto viene confermato dopo la valutazione delle foto: il preventivo è gratuito.",
    },
    {
        q: "Quanto tempo richiede l'intervento?",
        a: "Dipende dal pacchetto e dalle condizioni del faro. Ti diamo un'indicazione precisa in fase di preventivo, prima di fissare l'appuntamento.",
    },
    {
        q: "Quali zone servite con il servizio a domicilio?",
        a: `Operiamo a ${AREA}. Se sei in una zona limitrofa, scrivici: valutiamo caso per caso.`,
    },
    {
        q: "Quanto dura il risultato?",
        a: "I trattamenti con protezione CarPro C.Quartz DLUX hanno durata garantita fino a 2 anni; con l'Upgrade Premium (CarPro C.Quartz DLight) fino a 3 anni. La durata reale dipende anche da esposizione e manutenzione.",
    },
    {
        q: "Come ricevo una valutazione?",
        a: "Ci contatti su WhatsApp e ci invii alcune fotografie dei fari. Da lì ti diamo un primo riscontro e, se il caso è adatto, concordiamo l'intervento.",
    },
];

// Icona WhatsApp (lucide non include il marchio)
export const WhatsAppIcon = ({ className = "h-5 w-5" }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
    </svg>
);
